export default function IncognitoIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 13a3.5 3.5 0 11-3.497 3.644 3.003 3.003 0 00-2.007-.001 3.5 3.5 0 11-.494-1.94c.483-.152.988-.231 1.498-.231l.29.009c.41.024.816.098 1.207.22A3.5 3.5 0 0116.5 13zm-9 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm9 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM13.788 4.35a2.001 2.001 0 012.49 1.153l1.637 4.092c.706.078 1.442.17 2.219.275l.991.133-.268 1.983-.99-.134c-5.956-.805-9.344-.803-15.741.01l-.992.126-.252-1.985.992-.126c.772-.098 1.503-.184 2.201-.26l1.646-4.113a2.001 2.001 0 012.487-1.152l.001-.001 1.474.49c.205.067.428.068.632 0l1.473-.491zm-.84 2.388a3.001 3.001 0 01-1.896 0v-.001l-1.473-.488h-.002L8.313 9.407a46.445 46.445 0 017.364-.022l-1.255-3.14h-.001l-1.473.492z"
        fill={props.fill}
      />
    </svg>
  )
}